class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
        console.log('my code ------------11');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      loadaddShippingProtection();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
$(document).ready(function() {
  $(document).on('click', '.upsell-btn', function() {
    const $button = $(this);
    const variantId = $button.data('id');
    const $spinnerContainer = $button.find('.loading-spinner'); // Find the spinner within the container
    const $btnText = $button.find('.btn__text');
    
    if (!variantId) return;

    // Show the loading spinner
    $spinnerContainer.show();  // Show spinner
    $spinnerContainer.find('.loading__spinner').removeClass('hidden');
    $btnText.hide();  // Hide button text
    $button.prop('disabled', true);  // Disable the button to prevent multiple clicks

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ id: variantId, quantity: 1 }),
      success: function() {
        $.get('/?sections=cart-drawer,cart-icon-bubble', function(parsedSections) {
          const cartDrawerEl = $('cart-drawer');
          if (cartDrawerEl.length) {
            cartDrawerEl.get(0).renderContents({
              id: variantId,
              sections: parsedSections,
            });
          }
initSwiper();
          // Hide the loading spinner after adding to cart
          $spinnerContainer.hide();  // Hide spinner
          $spinnerContainer.find('.loading__spinner').addClass('hidden');
          $btnText.show();  // Show button text
          $button.prop('disabled', false);  // Re-enable the button
          cartDrawerEl.removeClass('is-empty');
        });
      },
      error: function(err) {
        console.error('Upsell error:', err);
        $spinnerContainer.hide();  // Hide spinner in case of an error
        $spinnerContainer.find('.loading__spinner').addClass('hidden');
        $btnText.show();  // Show button text
        $button.prop('disabled', false);  // Re-enable the button
      }
    });
  });
    $(document).on('click', '.empty_upsell-btn', function() {
    const $button = $(this);
    const variantId = $button.data('id');
    const $spinnerContainer = $button.find('.loading-spinner'); // Find the spinner within the container
    const $btnText = $button.find('.btn__text');
    
    if (!variantId) return;

    // Show the loading spinner
    $spinnerContainer.show();  // Show spinner
    $spinnerContainer.find('.loading__spinner').removeClass('hidden');
    $btnText.hide();  // Hide button text
    $button.prop('disabled', true);  // Disable the button to prevent multiple clicks

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ id: variantId, quantity: 1 }),
      success: function() {
        $.get('/?sections=cart-drawer,cart-icon-bubble', function(parsedSections) {
          const cartDrawerEl = $('cart-drawer');
          if (cartDrawerEl.length) {
            cartDrawerEl.get(0).renderContents({
              id: variantId,
              sections: parsedSections,
            });
          }
loadaddShippingProtection();
          initSwiper();
          // Hide the loading spinner after adding to cart
          $spinnerContainer.hide();  // Hide spinner
          $spinnerContainer.find('.loading__spinner').addClass('hidden');
          $btnText.show();  // Show button text
          $button.prop('disabled', false);  // Re-enable the button
          cartDrawerEl.removeClass('is-empty');
        });
      },
      error: function(err) {
        console.error('Upsell error:', err);
        $spinnerContainer.hide();  // Hide spinner in case of an error
        $spinnerContainer.find('.loading__spinner').addClass('hidden');
        $btnText.show();  // Show button text
        $button.prop('disabled', false);  // Re-enable the button
      }
    });
  });
});
function initSwiper() {
  const swiperEl = document.querySelector('.mySwiper');
  if (swiperEl) {
    new Swiper('.mySwiper', {
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', initSwiper);

// Run again after Shopify renders/replaces sections
document.addEventListener('shopify:section:load', initSwiper);
document.addEventListener('shopify:section:select', initSwiper);
document.addEventListener('shopify:section:deselect', initSwiper);
document.addEventListener('shopify:blocks:load', initSwiper);

function addShippingProtection(data) {

  const shipping_protection_toggle = $('#CartDrawer').attr('data-shippng');
  console.log(shipping_protection_toggle);
 if(shipping_protection_toggle == "true"){
    var varintid = $('#CartDrawer').attr('data-shippingid');

   $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ id: varintid, quantity: 1, properties:{ "shipping-protection": "true" } }),
      success: function() {
        $.get('/?sections=cart-drawer,cart-icon-bubble', function(parsedSections) {
          const cartDrawerEl = $('cart-drawer');
          if (cartDrawerEl.length) {
            cartDrawerEl.get(0).renderContents({
              id: varintid,
              sections: parsedSections,
            });
            initSwiper();
          }
        });
      },
      error: function(err) {
        console.error('Upsell error:', err);
      }
    });

    }
}
function removeShippingProtection(cart) {

      const shippingProtectionItem = cart.items.find(
        item => item.properties && item.properties["shipping-protection"] === "true"
      );

      if (shippingProtectionItem && cart.items.length === 1) {
        console.log('Only shipping protection in cart — clearing it.');

        // Clear the cart
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        })
          .then(() => {
            // Request the updated sections
            return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
          })
          .then(res => res.json())
          .then((parsedSections) => {
            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer) {
              const drawerHTML = new DOMParser().parseFromString(parsedSections['cart-drawer'], 'text/html');
              const bubbleHTML = new DOMParser().parseFromString(parsedSections['cart-icon-bubble'], 'text/html');

              const newDrawerInner = drawerHTML.querySelector('#CartDrawer .drawer__inner');
              const existingDrawerInner = cartDrawer.querySelector('.drawer__inner');
              if (newDrawerInner && existingDrawerInner) {
                existingDrawerInner.innerHTML = newDrawerInner.innerHTML;
              }

              const cartBubble = document.querySelector('#cart-icon-bubble');
              const newCartBubble = bubbleHTML.querySelector('#cart-icon-bubble');
              if (newCartBubble && cartBubble) {
                cartBubble.innerHTML = newCartBubble.innerHTML;
              }
initSwiper();
              cartDrawer.classList.add('is-empty'); // Force drawer into empty state
              $('.cart-count-bubble').html('');
            }
          })
          .catch(err => console.error("Error clearing cart or updating DOM:", err));
      }
}
function loadaddShippingProtection(){


  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

       console.log('add Protection ------------cart',cart);
const shippingProtectionItem = cart.items.find(
      item => item.id === 50081107640657
    );
      console.log('shippingProtectionItem', shippingProtectionItem);
      const shipping_protection_toggle = $('#CartDrawer').attr('data-shippng');
      const shipping_protection_auto = $('#CartDrawer').attr('data-autoenabled');
  console.log('add Protection ------------shipping_protection_auto',shipping_protection_auto, cart.items.length);
      
      if (shipping_protection_auto == "true" && cart.items.length === 1 && !shippingProtectionItem ) {
        console.log(' shipping protection in cart — add it.');

          
      console.log(shipping_protection_toggle);
        var varintid = $('#CartDrawer').attr('data-shippingid');
      console.log('add Protection ------------varintid',varintid);
       $.ajax({
          url: '/cart/add.js',
          method: 'POST',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({ id: varintid, quantity: 1, properties:{ "shipping-protection": "true" } }),
          success: function(mycart) {
              console.log('add Protection ------------mycart',mycart);
            $.get('/?sections=cart-drawer,cart-icon-bubble', function(parsedSections) {
              const cartDrawerEl = $('cart-drawer');
              if (cartDrawerEl.length) {
                cartDrawerEl.get(0).renderContents({
                  id: varintid,
                  sections: parsedSections,
                });
                initSwiper();
              }
            });

            
          },
          error: function(err) {
            console.error('Upsell error:', err);
          }
        });
    
      }
    })
    .catch(err => console.error("Error fetching cart:", err));
}

// $( document ).ready(function() {
//   loadaddShippingProtection();
// });



$(document).on('click', '#shipping_protection_toggle', function(event){
  if (!$(this).is(':checked')) {
    console.log('Shipping protection was unchecked!');
    var varintid = $('#CartDrawer').attr('data-shippingid');

  
     $.ajax({
  url: '/cart/change.js',
  method: 'POST',
  contentType: 'application/json',
  dataType: 'json',
  data: JSON.stringify({
    id: varintid,         // Variant ID of shipping protection
    quantity: 0           // Set to 0 to remove it from the cart
  }),
  success: function() {
    $.get('/?sections=cart-drawer,cart-icon-bubble', function(parsedSections) {
      // Update the UI
     const cartDrawerEl = $('cart-drawer');
          if (cartDrawerEl.length) {
            cartDrawerEl.get(0).renderContents({
              id: varintid,
              sections: parsedSections,
            });
            initSwiper();
          }
    });
  },
  error: function(err) {
    console.error('Error removing shipping protection:', err);
  }
});

    // Add your logic here (e.g., remove the item from the cart)
  } else {
    console.log('Shipping protection was checked!');
    // Optional logic when it's checked
    addShippingProtection();
  }
});

function watchKatchingChanges() {
  let isInternalUpdate = false;
  let isUserAction = false;

  document.addEventListener("click", (e) => {
    const toggleBtn = e.target.closest(".kaching-upsell-toggle-item");

    if (e.isTrusted && toggleBtn) {
      isUserAction = true;

      setTimeout(() => {
        isUserAction = false;
      }, 4000);
    }
  });

  const observer = new MutationObserver((mutations) => {
    if (isInternalUpdate) return;

    if (isUserAction) return;

    for (const mutation of mutations) {
      let matchedBundle = null;

      if (mutation.target instanceof Element) {
        matchedBundle = mutation.target.closest("kaching-cart-drawer");
      }

      if (!matchedBundle && mutation.type === "childList") {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches("katching-cart-bundle")) {
            matchedBundle = node;
            break;
          }

          const nestedBundle = node.querySelector("katching-cart-bundle");
          if (nestedBundle) {
            matchedBundle = nestedBundle;
            break;
          }
        }
      }

      if (!matchedBundle) continue;

      const toggleBtn = document.querySelector(
  ".kaching-upsell-toggle-item .kaching-cart-toggle"
);

// Auto-enable only when this toggle belongs to Variant A.
const variantContainer = toggleBtn?.closest("[data-ab-test-variant]");

if (variantContainer?.getAttribute("data-ab-test-variant") !== "A") {
  continue;
}

      if (
        toggleBtn &&
        !toggleBtn.classList.contains("kaching-cart-toggle__active")
      ) {
        isInternalUpdate = true;

        toggleBtn.click();

        setTimeout(() => {
          isInternalUpdate = false;
        }, 150);
      }

      break;
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  });

  return observer;
}

watchKatchingChanges();